export type DownloadItem = {
  url: string;
  title?: string;
};

async function downloadBlob(blob: Blob, filename: string): Promise<void> {
  return new Promise((resolve) => {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);

    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    // Use a more reliable approach for mobile
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');

    document.body.appendChild(link);

    // Trigger download with user gesture context
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    link.dispatchEvent(clickEvent);

    // Cleanup with longer timeout for mobile
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      resolve();
    }, 500);
  });
}

export async function downloadFiles(items: DownloadItem[]): Promise<void> {
  for (const item of items) {
    try {
      const response = await fetch(item.url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${item.url}`);
      }
      const blob = await response.blob();

      // Create a more reliable download function
      await downloadBlob(
        blob,
        item.title || `${item.url.split('/').reverse()[0]}`
      );

      await new Promise((resolve) => setTimeout(resolve, 200));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error downloading ${item.url}:`, error);
    }
  }
}
